import script from "./AdvancedComparisonProductResultAction.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvancedComparisonProductResultAction.vue?vue&type=script&setup=true&lang=js"

import "./AdvancedComparisonProductResultAction.vue?vue&type=style&index=0&id=5d74c4b4&lang=less"

const __exports__ = script;

export default __exports__